import { render, staticRenderFns } from "./SubscriptionCompleted.vue?vue&type=template&id=368bddd8&scoped=true&"
import script from "./SubscriptionCompleted.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionCompleted.vue?vue&type=style&index=0&id=368bddd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368bddd8",
  null
  
)

export default component.exports